module.exports = __webpack_public_path__ + "img/Dantam Hair 49.24b4655c.jpg";